export function dataInRequest(params = {}) {
  return {
    type: '@atendimentoPosto/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@atendimentoPosto/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@atendimentoPosto/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@atendimentoPosto/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@atendimentoPosto/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@atendimentoPosto/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@atendimentoPosto/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@atendimentoPosto/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@atendimentoPosto/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@atendimentoPosto/RECORD_FILTERING',
    payload: { params },
  };
}
